import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getAccount, changePassword, updateSelectedTenant } from "../api";
import { useNotification } from "../../../contexts/NotificationContext";

export const useGetAccount = () => {
  const token =
    typeof window !== "undefined" ? localStorage.getItem("token") : null;

  const { data, isLoading, isError, error, isSuccess, isFetched } = useQuery({
    queryKey: ["account"],
    queryFn: () => getAccount(),
    enabled: !!token,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return { data, isLoading, isSuccess, isFetched, isError, error };
};

export const useChangePassword = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: (data) => changePassword(data),
    onSuccess: () => {
      showNotification('success', 'Password changed successfully!');
    },
    onError: (error) => {
      console.error("Error changing password:", error);

      let errorMessage = 'An error occurred while changing the password. Please try again.';
      if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      showNotification('danger', errorMessage);
    },
  });
};

export const useUpdateSelectedTenant = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: (data) => updateSelectedTenant(data),
    onSuccess: () => {
      queryClient.invalidateQueries(['account']);
    },
    onError: (error) => {
      console.error("Error updating tenant:", error);

      let errorMessage = 'An error occurred while updating the tenant. Please try again.';
      if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      showNotification('danger', errorMessage);
    },
  });
};

